import actions from "./actions";

const {
    FETCH_USER_ATTENDANCE_PERMISSION,
    FETCH_USER_ATTENDANCE_PERMISSIONS,
    RESET_USER_ATTENDANCE_PERMISSION
} = actions;

const initState = {
    userPermissions: [],
    userPermission: { _id: null }
};

const UserAttendancePermissionReducer = (state = initState, action) => {
    const { type, data } = action;
    switch (type) {
        case FETCH_USER_ATTENDANCE_PERMISSIONS:
            return {
                ...state,
                userPermissions: data
            };
        case RESET_USER_ATTENDANCE_PERMISSION:
            return {
                ...state,
                userPermission: initState.userPermission,
            };
        case FETCH_USER_ATTENDANCE_PERMISSION:
            return {
                ...state,
                userPermission: data,
            };
        default:
            return state;
    }
};

export default UserAttendancePermissionReducer;
